import { EventCategory } from "@/types/events";
export const modalImages = {
    [EventCategory.NIVEL_RIOS]: "/modal-headers/nivel-dos-rios.jpg",
    [EventCategory.AREA_ALAGAMENTO]: "/modal-headers/alagamento.png",
    [EventCategory.CHUVAS]: "/modal-headers/chuva.png",
    [EventCategory.BARRAGENS]: "/modal-headers/barragens.png",
    [EventCategory.VENDAVAL]: "/modal-headers/vendaval.png",
    [EventCategory.INCENDIO]: "/modal-headers/incendios.jpg",
    [EventCategory.DESLIZAMENTO]: "/modal-headers/deslizamento.png",
    [EventCategory.PERDA_SOLO]: "/modal-headers/perda-solo.jpg",
    [EventCategory.PRODUTOS_QUIMICOS]: "/modal-headers/produtos-quimicos.png",
    [EventCategory.TREMOR]: "/modal-headers/tremor.jpg",
};
export const getModalImage = (category) => {
    if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/v1/static-content/app-sistema-pluviometrico/${modalImages[category]}`;
    }
    return `${process.env.PUBLIC_URL}${modalImages[category]}`;
};
export const handleCategoryDescription = {
    [EventCategory.NIVEL_RIOS]: "Transbordamento de rios, riachos ou corpos d’água que provoca o avanço da água sobre áreas normalmente secas.",
    [EventCategory.AREA_ALAGAMENTO]: "Acúmulo temporário de água em áreas urbanas ou rurais devido à chuva intensa e à insuficiência da drenagem local.",
    [EventCategory.CHUVAS]: "Precipitação de água das nuvens que pode causar impactos como alagamentos, inundações e outros danos quando ocorre de forma intensa.",
    [EventCategory.BARRAGENS]: "Rompimento total ou parcial de uma barragem, causando a liberação descontrolada de água, rejeitos ou sedimentos e gerando riscos à população, ao meio ambiente e à infraestrutura.",
    [EventCategory.VENDAVAL]: "Vento forte e persistente que pode causar danos a edificações, queda de árvores, interrupção de serviços e outros impactos à população.",
    [EventCategory.INCENDIO]: "Fogo sem controle que se propaga em áreas urbanas, rurais ou florestais, causando danos ao meio ambiente, ao patrimônio e à população.",
    [EventCategory.DESLIZAMENTO]: "Movimento de terra, rochas ou outros materiais em encostas, podendo causar danos a pessoas, edificações e infraestrutura.",
    [EventCategory.PERDA_SOLO]: "Desgaste e remoção do solo pela ação da água, do vento ou de atividades humanas, podendo comprometer áreas naturais e estruturas.",
    [EventCategory.PRODUTOS_QUIMICOS]: "Ocorrência envolvendo vazamento, derramamento ou liberação de substâncias químicas que podem representar riscos à saúde humana, ao meio ambiente e à infraestrutura.",
    [EventCategory.TREMOR]: "Movimento repentino da crosta terrestre que pode provocar vibrações no solo e causar danos de diferentes intensidades.",
};
export const getCategoryDescription = (category) => {
    return handleCategoryDescription[category];
};
